import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChartDataService {

  // Array of month names
  private monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor() { }

  // Method to sort and transform xValue to month names
  convertXValueFromYearMonthToMonthName(data: any[]): any[] {
    if(data){
    return data?.sort((a, b) => {
      const [yearA, monthA] = a?.xValue.split('-').map(Number);
      const [yearB, monthB] = b?.xValue.split('-').map(Number);
      return yearA - yearB || monthA - monthB;
    }).map(item => {
      const monthNumber = Number(item.xValue.split('-')[1]) - 1; // Convert to zero-based index
      return {
        ...item,
        xValue: this.monthNames[monthNumber] // Replace xValue with the month name
      };
    });
  } else {
    return [];
  }
}
}